export default "__VITE_ASSET__CztpZdru__"